// Heat-t -> CSS color for the anatomical body map (MUSCLE_BODY_MAP_PLAN.md,
// Task 6.1). Blue (untrained) -> pale red -> deep red (D-BM-5). The palette is
// Past target (t > 1, up to HEAT_OVER_TARGET_MAX) the ramp keeps darkening from
// deep red to crimson (D-HR-3); t <= 1 output is unchanged (D-HR-2, pain map).
// The palette is fixed via the --bodymap-* CSS vars in web/src/index.css, not per-patient.
// User-facing scale captions (capped-target vs relative-to-max) live in
// shared heatLegend() so a labelling change cannot silently retint the map.
import { HEAT_OVER_TARGET_MAX } from "@medassist/shared";

/** Returns an SVG `fill` value for a heat t from muscleHeatT. */
export function heatFill(t: number | null): string {
  if (t === null) return "var(--bodymap-cold)";
  if (t > 1) {
    const over = Math.min(1, (t - 1) / (HEAT_OVER_TARGET_MAX - 1));
    return `hsl(${360 - 12 * over} ${90 - 10 * over}% ${36 - 12 * over}%)`;
  }
  const light = 78 - 42 * t; // 78% (pale) -> 36% (deep)
  const sat = 62 + 28 * t; // 62% -> 90%
  return `hsl(0 ${sat}% ${light}%)`;
}

/** Neutral fill for uncertain-exposure-only muscles (D-TA-6). Not the red ramp
 *  and not the cold "untrained" blue. */
export function uncertainExposureFill(): string {
  return "var(--bodymap-uncertain)";
}

/** Teal fill for aerobic/mobility use that does not count toward the strength target (D-1, D-5). */
export function usedExposureFill(): string {
  return "var(--bodymap-used)";
}
